module.exports = __webpack_public_path__ + "img/maya.6f68083f.png";